module.exports = __webpack_public_path__ + "static/logo-lazaridis-ss@2x-660dbcfd734fac67c72c52f7b840511f.png";